import styled from 'styled-components';
import { Icon } from '@mdi/react';
const StyledMaterialIcon = styled(Icon)`
  display: ${({
  $display: display
}) => display};
  vertical-align: ${({
  'data-align': align
}) => align};
  line-height: inherit;
  flex-shrink: 0;
`;
export default StyledMaterialIcon;
//# sourceMappingURL=styles.js.map